import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  tableCellIcon: {
    width: 48,
    paddingRight: 0,
  },
  tableCellDetails: {
    '& > *:not(:last-child)': {
      marginBottom: 4,
    },
  },
  fix: {
    lineHeight: '1.5em',
    fontSize: '1em',
  },
});
